var _circle, _path, _path2, _circle2, _ellipse, _ellipse2, _path3, _path4, _rect, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FCE4D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6571 38.0007C11.5504 37.3453 11.963 32.4482 11.9327 30.0815L17.03 30.8097L19.4877 38.5468L9.6571 38.0007Z",
    fill: "#96694F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8521 38.0007C39.9587 37.3453 39.5461 32.4482 39.5765 30.0815L34.4791 30.8097L32.0215 38.5468L41.8521 38.0007Z",
    fill: "#96694F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6175,
    cy: 26.0002,
    r: 14.8571,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.0313,
    cy: 29.0741,
    rx: 1.02463,
    ry: 1.53695,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.2283,
    cy: 29.0741,
    rx: 1.02463,
    ry: 1.53695,
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9853 32.9757L23.8256 31.687C23.5224 32.6657 24.029 33.6272 25.4971 34.082C26.8813 34.5109 27.7015 33.6029 27.9853 32.9757Z",
    fill: "#F09387"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7784 26.739L21.2782 20.6906C24.2497 22.7541 31.4815 24.9291 40.4434 26.971C40.4641 26.6501 40.4746 26.3264 40.4746 26.0002C40.4746 17.7948 33.8228 11.1431 25.6175 11.1431C17.4121 11.1431 10.7603 17.7948 10.7603 26.0002C10.7603 26.2479 10.7664 26.4942 10.7784 26.739Z",
    fill: "#96694F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.8939,
    y: 18.6953,
    width: 0.839954,
    height: 6.71913,
    transform: "rotate(17.9005 34.8939 18.6953)",
    fill: "#82C3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.837 29.6203C24.7725 29.8877 24.5286 30.1562 24.0503 30.3224C23.5781 30.4866 22.9409 30.5217 22.2597 30.3574C21.5784 30.193 21.0273 29.8712 20.6819 29.5097C20.3321 29.1437 20.2374 28.7935 20.3019 28.5261C20.3665 28.2588 20.6104 27.9903 21.0886 27.824C21.5608 27.6598 22.198 27.6247 22.8793 27.7891C23.5606 27.9534 24.1116 28.2752 24.4571 28.6367C24.8069 29.0028 24.9015 29.3529 24.837 29.6203Z",
    fill: "black",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1666 29.6203C27.2311 29.8877 27.475 30.1562 27.9533 30.3224C28.4255 30.4866 29.0627 30.5217 29.744 30.3574C30.4252 30.193 30.9763 29.8712 31.3217 29.5097C31.6715 29.1437 31.7662 28.7935 31.7017 28.5261C31.6371 28.2588 31.3932 27.9903 30.915 27.824C30.4428 27.6598 29.8056 27.6247 29.1243 27.7891C28.443 27.9534 27.892 28.2752 27.5465 28.6367C27.1967 29.0028 27.1021 29.3529 27.1666 29.6203Z",
    fill: "black",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2179 29.4224H28.0326",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile12);
export default __webpack_public_path__ + "static/media/img_profile_12.718c7cc81db8b5a8af4a13e6a73709ea.svg";
export { ForwardRef as ReactComponent };